import { API_BASE_URL } from "src/config/apiBase";

/** Use /api/* paths — matched by setupProxy "api" segment in local dev. */
export function themeAdminUrl(path = "") {
  const base = API_BASE_URL.replace(/\/+$/, "");
  const suffix = path.startsWith("/") ? path : path ? `/${path}` : "";
  return `${base}/api/themes${suffix}`;
}

export function siteThemeAdminUrl(path = "") {
  const base = API_BASE_URL.replace(/\/+$/, "");
  const suffix = path.startsWith("/") ? path : path ? `/${path}` : "";
  return `${base}/api/site-themes${suffix}`;
}

export function provisioningAdminUrl(path = "") {
  const base = API_BASE_URL.replace(/\/+$/, "");
  const suffix = path.startsWith("/") ? path : path ? `/${path}` : "";
  return `${base}/api/provisioning${suffix}`;
}

const DEPLOY_HINT =
  "Theme API not found. Deploy the latest Backend (theme routes), restart the API, and restart Admin dev server if testing locally.";

/** Parse theme API responses; never throw raw JSON parse errors on HTML bodies. */
export async function parseThemeApiResponse(response) {
  const text = await response.text();
  const trimmed = text.trim();

  if (!trimmed) {
    return { isError: true, message: `Empty response (${response.status})` };
  }

  if (trimmed.startsWith("<") || trimmed.startsWith("<!DOCTYPE")) {
    if (response.status === 404 || trimmed.includes("Cannot POST") || trimmed.includes("Cannot GET")) {
      throw new Error(DEPLOY_HINT);
    }
    throw new Error(
      "Server returned HTML instead of JSON. Check API URL / proxy config (Admin setupProxy.js)."
    );
  }

  try {
    return JSON.parse(trimmed);
  } catch {
    throw new Error(`Invalid JSON from server (${response.status}).`);
  }
}
